import axios from 'axios'
import store from '@/store/store'

export default () => {
  return axios.create({
//    baseURL: `http://localhost:8081/`,
//    baseURL: `http://52.60.193.180:8081/`,
//    baseURL: `https://vitalv2.vsmp.ca/`,
    baseURL: `https://vitalv2-staging.vsmp.ca/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js